var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example"},[_c('div',{staticClass:"screen"},_vm._l((_vm.widgets),function(widget){return _c('div',{key:widget.key,staticClass:"panel",style:({
          height: ((widget.height) + "px"),
          width: ((widget.width) + "px"),
          top: ((widget.y) + "px"),
          left: ((widget.x) + "px"),
        }),attrs:{"id":widget.key}})}),0),_c('animation-timeline',{staticStyle:{"height":"600px"},attrs:{"widgets":_vm.widgets,"fields":_vm.fields},on:{"onUpdate":_vm.handleUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }